export function initialize() {
    $.fn.followTo = function (pos) {
        var $window = $(window);

        var viewableNav = $('#he-fix').height();

        $window.scroll(function (e) {
            if ($window.scrollTop() < viewableNav) {
                $('#nav-box').removeClass('navbar-background');
            } else {
                $('#nav-box').addClass('navbar-background');
            }
        });
    };

    var viewableOffset = $('#nav-box').offset().top;
    $('#nav-box').followTo(viewableOffset);
}

export default {};
